function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { nameOf, initialsOf } from "./collab";

/*
 * Content Hub collaboration, phase 3 (PlunkDocs specs/CONTENT_HUB_REVIEW_DESK_2026-10-21.md §4.1-4.2, mockups A and B).
 * NotesPanel: a piece's threads. A note can point at words (quote + position; "Show in the piece" finds them again and a
 * note whose words were rewritten says so), replies, @mentions (people in the workspace; they hear about it in the
 * bell), resolve / reopen (the thread's author or a moderator). PeopleRow: the piece's Copy and Media assignees with
 * due dates. Both read and write through the Builder (b.notesFor, b.postNote, b.resolveNote, b.assign).
 */
const when = iso => {
  const d = new Date(iso);
  return isNaN(d) ? "" : d.toLocaleString([], {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit"
  });
};
const norm = s => String(s || "").replace(/\s+/g, " ").trim().toLowerCase();
const nameFor = (b, email) => {
  const u = b.teamUsers().find(x => x.email === String(email || "").toLowerCase());
  return u && u.name || nameOf(email);
};

/** Text with @Name mentions picked out. */
function NoteText({
  text,
  names
}) {
  const list = (names || []).filter(Boolean).sort((a, b) => b.length - a.length);
  if (!list.length) return /*#__PURE__*/React.createElement("div", {
    className: "bm-note-text"
  }, text);
  const esc = list.map(n => n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  const parts = String(text).split(new RegExp(`(@(?:${esc.join("|")}))`, "g"));
  return /*#__PURE__*/React.createElement("div", {
    className: "bm-note-text"
  }, parts.map((t, i) => t.startsWith("@") && list.includes(t.slice(1)) ? /*#__PURE__*/React.createElement("b", {
    key: i,
    className: "bm-mention"
  }, t) : /*#__PURE__*/React.createElement("span", {
    key: i
  }, t)));
}

/** A note box with @mention suggestions. onSubmit(text, mentionEmails). */
class Composer extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      text: "",
      picked: {},
      q: null,
      hi: 0,
      busy: false
    });
    _defineProperty(this, "onChange", e => {
      const text = e.target.value;
      const upto = text.slice(0, e.target.selectionStart || text.length);
      const m = this.props.b.teamOn() ? /(^|\s)@([\w.'-]{0,30})$/.exec(upto) : null;
      this.setState({
        text,
        q: m ? m[2] : null,
        hi: 0
      });
    });
    _defineProperty(this, "pick", u => {
      const ta = this._ta;
      const text = this.state.text;
      const caret = ta ? ta.selectionStart : text.length;
      const before = text.slice(0, caret).replace(/@([\w.'-]{0,30})$/, `@${u.name} `);
      this.setState({
        text: before + text.slice(caret),
        picked: {
          ...this.state.picked,
          [u.name]: u.email
        },
        q: null
      }, () => {
        if (ta) {
          ta.focus();
          ta.selectionStart = ta.selectionEnd = before.length;
        }
      });
    });
    _defineProperty(this, "onKey", e => {
      const list = this.matches();
      if (list.length) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          this.setState({
            hi: (this.state.hi + 1) % list.length
          });
          return;
        }
        if (e.key === "ArrowUp") {
          e.preventDefault();
          this.setState({
            hi: (this.state.hi + list.length - 1) % list.length
          });
          return;
        }
        if (e.key === "Enter" || e.key === "Tab") {
          e.preventDefault();
          this.pick(list[this.state.hi] || list[0]);
          return;
        }
        if (e.key === "Escape") {
          this.setState({
            q: null
          });
          return;
        }
      }
      if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        this.submit();
      }
      if (e.key === "Escape" && this.props.onCancel) this.props.onCancel();
    });
    _defineProperty(this, "submit", async () => {
      const text = this.state.text.trim();
      if (!text || this.state.busy) return;
      const mentions = Object.keys(this.state.picked).filter(n => text.includes(`@${n}`)).map(n => this.state.picked[n]);
      this.setState({
        busy: true
      });
      const ok = await this.props.onSubmit(text, mentions);
      this.setState(ok ? {
        text: "",
        picked: {},
        q: null,
        busy: false
      } : {
        busy: false
      });
    });
  }
  focus() {
    if (this._ta) this._ta.focus();
  }
  matches() {
    const {
      q
    } = this.state;
    if (q == null) return [];
    const me = this.props.b.me();
    const t = q.toLowerCase();
    return this.props.b.teamUsers().filter(u => u.email !== me && (!t || u.name.toLowerCase().split(" ").some(w => w.startsWith(t)) || u.email.startsWith(t))).slice(0, 6);
  }
  render() {
    const list = this.matches();
    const {
      text,
      busy
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      className: "bm-compose"
    }, /*#__PURE__*/React.createElement("textarea", {
      ref: el => {
        this._ta = el;
      },
      id: this.props.id,
      rows: this.props.rows || 2,
      value: text,
      placeholder: this.props.placeholder,
      onChange: this.onChange,
      onKeyDown: this.onKey,
      "aria-autocomplete": "list",
      "aria-expanded": list.length > 0
    }), list.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "bm-mention-list",
      role: "listbox",
      "aria-label": "People"
    }, list.map((u, i) => /*#__PURE__*/React.createElement("button", {
      key: u.email,
      type: "button",
      role: "option",
      "aria-selected": i === this.state.hi,
      className: i === this.state.hi ? "on" : "",
      onMouseDown: e => {
        e.preventDefault();
        this.pick(u);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "bm-av"
    }, initialsOf(u.email)), /*#__PURE__*/React.createElement("b", null, u.name), /*#__PURE__*/React.createElement("i", null, u.email)))), /*#__PURE__*/React.createElement("div", {
      className: "bm-row-acts"
    }, /*#__PURE__*/React.createElement("button", {
      className: "bm-btn sm",
      disabled: !text.trim() || busy,
      onClick: this.submit
    }, busy ? "Posting…" : this.props.cta || "Post"), this.props.onCancel && /*#__PURE__*/React.createElement("button", {
      className: "bm-link mute",
      onClick: this.props.onCancel
    }, "Cancel"), this.props.b.teamOn() && /*#__PURE__*/React.createElement("span", {
      className: "bm-sub"
    }, "Type @ to bring someone in.")));
  }
}
export class NotesPanel extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      reply: null,
      showResolved: false
    });
  }
  focus() {
    if (this._top) this._top.focus();
  }
  canResolve(t) {
    const b = this.props.b;
    return t.by && (String(t.by).toLowerCase() === b.me() || b.isModerator());
  }
  renderNote(c, thread) {
    const b = this.props.b;
    const names = (c.mentions || []).map(m => nameFor(b, m));
    return /*#__PURE__*/React.createElement("div", {
      className: "bm-note",
      key: c.id
    }, /*#__PURE__*/React.createElement("span", {
      className: "bm-av"
    }, c.by ? initialsOf(c.by) : "?"), /*#__PURE__*/React.createElement("div", {
      className: "bm-note-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bm-note-hd"
    }, /*#__PURE__*/React.createElement("b", null, c.byName || (c.by ? nameFor(b, c.by) : "Someone")), /*#__PURE__*/React.createElement("span", {
      className: "bm-sub"
    }, when(c.at))), thread && this.renderAnchor(c), /*#__PURE__*/React.createElement(NoteText, {
      text: c.text,
      names: names
    })));
  }
  renderAnchor(c) {
    const a = c.anchor;
    if (!a) return null;
    if (a.media) return /*#__PURE__*/React.createElement("div", {
      className: "bm-anchor media"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, a.media === "video" ? "movie" : "image"), a.media === "video" ? `The video${a.t != null ? ` at ${Math.floor(a.t / 60)}:${String(Math.round(a.t % 60)).padStart(2, "0")}` : ""}` : "The picture");
    if (!a.quote) return null;
    const gone = !norm(this.props.plain).includes(norm(a.quote));
    return /*#__PURE__*/React.createElement("div", {
      className: "bm-anchor" + (gone ? " gone" : "")
    }, /*#__PURE__*/React.createElement("q", null, a.quote.length > 140 ? a.quote.slice(0, 139) + "…" : a.quote), gone ? /*#__PURE__*/React.createElement("span", {
      className: "bm-sub left"
    }, "These words have since been rewritten.") : /*#__PURE__*/React.createElement("button", {
      className: "bm-link",
      onClick: () => this.props.onShow(a.quote)
    }, "Show in the piece"));
  }
  render() {
    const {
      b,
      v,
      anchor
    } = this.props;
    const threads = b.notesFor(v);
    const open = threads.filter(t => !t.resolvedAt);
    const done = threads.filter(t => t.resolvedAt);
    const shown = this.state.showResolved ? open.concat(done) : open;
    return /*#__PURE__*/React.createElement("div", {
      className: "bm-notes"
    }, shown.map(t => /*#__PURE__*/React.createElement("div", {
      key: t.id,
      className: "bm-thread" + (t.resolvedAt ? " resolved" : "")
    }, this.renderNote(t, true), t.replies.map(r => this.renderNote(r, false)), /*#__PURE__*/React.createElement("div", {
      className: "bm-row-acts bm-thread-acts"
    }, t.resolvedAt ? /*#__PURE__*/React.createElement("span", {
      className: "bm-sub left"
    }, "Resolved by ", nameFor(b, t.resolvedBy)) : /*#__PURE__*/React.createElement("button", {
      className: "bm-link",
      onClick: () => this.setState({
        reply: this.state.reply === t.id ? null : t.id
      })
    }, "Reply"), this.canResolve(t) && /*#__PURE__*/React.createElement("button", {
      className: "bm-link mute",
      onClick: () => b.resolveNote(t.id, !t.resolvedAt)
    }, t.resolvedAt ? "Reopen" : "Resolve")), this.state.reply === t.id && /*#__PURE__*/React.createElement(Composer, {
      b: b,
      rows: 2,
      placeholder: "Reply",
      cta: "Reply",
      onCancel: () => this.setState({
        reply: null
      }),
      onSubmit: async (text, mentions) => {
        const ok = await b.postNote(v, {
          text,
          mentions,
          parentId: t.id
        });
        if (ok) this.setState({
          reply: null
        });
        return ok;
      }
    }))), !threads.length && /*#__PURE__*/React.createElement("p", {
      className: "bm-sub left"
    }, b.teamOn() ? "No notes yet. Select words in the preview to comment on them, or leave a general note." : "No notes yet."), done.length > 0 && /*#__PURE__*/React.createElement("button", {
      className: "bm-link mute",
      onClick: () => this.setState({
        showResolved: !this.state.showResolved
      })
    }, this.state.showResolved ? "Hide resolved" : `Show ${done.length} resolved`), anchor && /*#__PURE__*/React.createElement("div", {
      className: "bm-anchor pending"
    }, /*#__PURE__*/React.createElement("q", null, anchor.quote.length > 140 ? anchor.quote.slice(0, 139) + "…" : anchor.quote), /*#__PURE__*/React.createElement("button", {
      className: "bm-link mute",
      "aria-label": "Don't point at these words",
      onClick: this.props.onClearAnchor
    }, "Remove")), /*#__PURE__*/React.createElement(Composer, {
      ref: el => {
        this._top = el;
      },
      b: b,
      id: `bm-note-${v.id}`,
      placeholder: anchor ? "Your note on these words" : "Leave a note for the team",
      onSubmit: async (text, mentions) => {
        const ok = await b.postNote(v, {
          text,
          mentions,
          anchor: anchor || null
        });
        if (ok && anchor) this.props.onClearAnchor();
        return ok;
      }
    }));
  }
}

/** Copy and Media assignees with due dates for one piece (team workspaces only). */
export function PeopleRow({
  b,
  v
}) {
  const as = b.assigneesFor(v);
  const users = b.teamUsers();
  const today = new Date().toISOString().slice(0, 10);
  const row = (role, label, hint) => {
    const a = as[role] || {};
    const late = a.due && a.due < today && !["approved", "published", "live"].includes(String(v.status || "").toLowerCase());
    return /*#__PURE__*/React.createElement("div", {
      className: "bm-people-row",
      key: role
    }, /*#__PURE__*/React.createElement("label", {
      className: "bm-field",
      title: hint
    }, /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement("select", {
      value: a.assignee || "",
      onChange: e => b.assign(v, role, e.target.value, a.due)
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "Nobody yet"), users.map(u => /*#__PURE__*/React.createElement("option", {
      key: u.email,
      value: u.email
    }, u.name, u.email === b.me() ? " (me)" : "")))), /*#__PURE__*/React.createElement("label", {
      className: "bm-field due" + (late ? " late" : ""),
      title: "When it's due"
    }, /*#__PURE__*/React.createElement("span", null, late ? "Late" : "Due"), /*#__PURE__*/React.createElement("input", {
      type: "date",
      value: a.due || "",
      disabled: !a.assignee,
      onChange: e => b.assign(v, role, a.assignee, e.target.value)
    })));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "bm-sec bm-people"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bm-h"
  }, "Who's on it"), row("copy", "Words", "Who writes and edits the words"), row("media", "Pictures", "Who makes the pictures and video"), /*#__PURE__*/React.createElement("span", {
    className: "bm-sub left"
  }, "They hear about it in their notifications. Anyone can still edit."));
}

/** Initials for a piece's assignees in the piece list, late ones marked. */
export function AssigneeDots({
  b,
  v
}) {
  if (!v || !b.teamOn()) return null;
  const as = b.assigneesFor(v);
  const today = new Date().toISOString().slice(0, 10);
  const done = ["approved", "published", "live"].includes(String(v.status || "").toLowerCase());
  const list = ["copy", "media"].map(r => as[r] && {
    ...as[r],
    role: r
  }).filter(Boolean);
  if (!list.length) return null;
  return /*#__PURE__*/React.createElement("span", {
    className: "bm-assn",
    title: list.map(a => `${a.role === "copy" ? "Words" : "Pictures"}: ${nameFor(b, a.assignee)}${a.due ? `, due ${a.due}` : ""}`).join(" · ")
  }, list.map(a => /*#__PURE__*/React.createElement("span", {
    key: a.role,
    className: "bm-av sm" + (!done && a.due && a.due < today ? " late" : "")
  }, initialsOf(a.assignee))));
}

/** The story owner, for the piece list head. */
export function OwnerPicker({
  b
}) {
  if (!b.teamOn()) return null;
  const owner = b.storyOwner();
  const users = b.teamUsers();
  return /*#__PURE__*/React.createElement("label", {
    className: "bm-owner",
    title: "Who is responsible for the story as a whole"
  }, /*#__PURE__*/React.createElement("span", null, "Owner"), /*#__PURE__*/React.createElement("select", {
    value: owner && users.some(u => u.email === owner) ? owner : "",
    onChange: e => b.assign(null, "owner", e.target.value)
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Nobody yet"), users.map(u => /*#__PURE__*/React.createElement("option", {
    key: u.email,
    value: u.email
  }, u.name, u.email === b.me() ? " (me)" : ""))));
}